import { useEffect } from "react";
import { useHeader } from "../context/HeaderContext";

// Reusable IntersectionObserver hook for setting global header text
export default function useSectionHeader(ref, headerKey, options = {}) {
  const { setHeaderKey } = useHeader();

  const threshold = options.threshold ?? 0.4;

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHeaderKey(headerKey);
        }
      },
      { threshold }
    );

    observer.observe(el);

    return () => observer.disconnect();
    // eslint-disable-next-line
  }, [headerKey, setHeaderKey, threshold]);
}